import React, {Component} from 'react';
import {connect} from 'react-redux';

import {Button} from "reactstrap";

import {handleAddCard} from "../../containers/tenant/actions/billing";

import '../../assets/css/stripe.css';
import {FormAsyncButton} from "../controls/buttons/AsyncButton";

class StripeElementAddCard extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this._show_card_error = this._show_card_error.bind(this);
    }

    state = {
        submitting: false
    };

    _show_card_error(result) {
        // Inform the user if there was an error
        let errorElement = document.getElementById('card-errors');
        errorElement.textContent = result.error.message;
    }

    componentDidMount() {
        let stripe = window.Stripe(this.props.stripe_details.stripe_publishable_key);
        let elements = stripe.elements();

        const self = this;
        const _handleAddCard = this.props._handleAddCard;
        // Create an instance of the card Element
        let card = elements.create('card', {hidePostalCode: false});

        // Add an instance of the card Element into the `card-element` <div>
        card.mount('#card-element');

        // Handle real-time validation errors from the card Element.
        card.addEventListener('change', function (event) {
            let displayError = document.getElementById('card-errors');
            if (event.error) {
                displayError.textContent = event.error.message;
            } else {
                displayError.textContent = '';
            }
        });

        let form = document.getElementById('payment-form');
        form.addEventListener('submit', function (event) {
            event.preventDefault();

            stripe.createToken(card, {
                name: self.props.first_name + ' ' + self.props.last_name
            }).then(function (result) {
                if (result.error) {
                    self.setState({submitting: false});
                    self._show_card_error(result);
                } else {
                    // Send the token to the server
                    _handleAddCard(result.token).then((result) => {
                        self.setState({submitting: false});
                        if (result.error) {
                            self._show_card_error(result);
                        }
                        else {
                            self.props.onSubmit();
                        }
                    });
                }
            });
        });
    }

    cancel = () => {
        this.props.onCancel && this.props.onCancel();
    };

    submit = (form) => {
        this.setState({submitting: true});
    };

    render() {
        return (
            <div className="mt-3 mb-1">
                <form onSubmit={this.submit} id="payment-form">
                    <div>
                        <label htmlFor="card-element">
                            <h4>Add a credit or debit card</h4>
                        </label>
                        <div id="card-element">
                        </div>
                        <div id="card-errors" className="text-danger" role="alert">
                        </div>
                    </div>
                    <FormAsyncButton acting={this.state.submitting} type="submit" style={{margin: '.75em 0'}} color="primary">Add Card</FormAsyncButton>
                    <Button type="button" style={{margin: '.75em .75em'}} onClick={this.cancel}>Cancel</Button>
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    first_name: state.activeUser.first_name,
    last_name: state.activeUser.last_name,
    stripe_details: state.tenant.billing && state.tenant.billing.stripe_details
});

const mapDispatchToProps = (dispatch) => ({
    _handleAddCard(data) {
        return dispatch(handleAddCard(data.id));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(StripeElementAddCard);



// WEBPACK FOOTER //
// ./src/components/billing/StripeElementAddCard.js